/** Recorte da listagem pela busca local (função PURA) — o chamador decide o que é "texto buscável". */
export function filtrarPorTexto<T>(itens: readonly T[], busca: string, textoBuscavel: (item: T) => string): T[] {
    const termo = busca.trim().toLocaleLowerCase('pt-BR');
    if (!termo) {
        return [...itens];
    }
    return itens.filter((item) => textoBuscavel(item).toLocaleLowerCase('pt-BR').includes(termo));
}

/** Ordena a listagem (função PURA, sem mutar a entrada) pelo comparador do critério escolhido. */
export function ordenarPor<T>(itens: readonly T[], comparador: (a: T, b: T) => number): T[] {
    return [...itens].sort(comparador);
}
